var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgClients(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "current",
    d: "M3 21C3.82759 17.0985 6.31034 14.1726 10.4483 14.1725C14.5862 14.1724 17.069 17.0985 17.8966 21M22 19C21.4122 16.2516 19.6933 14.1641 16.8435 14.0093M16 4.06003C16.1616 4.02066 16.3288 4 16.5 4C17.8806 4 19 5.34328 19 7C19 8.6575 17.8806 10 16.5 10H16.4817C16.3168 9.99934 16.1558 9.97948 16 9.94219M10.4491 10.8621C12.2772 10.8621 13.7594 9.10293 13.7594 6.93103C13.7594 4.76016 12.2772 3 10.4491 3C8.621 3 7.13876 4.76016 7.13876 6.93103C7.13183 9.0947 8.6028 10.8549 10.4248 10.8621H10.4491Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClients);
export default __webpack_public_path__ + "static/media/clients.e6619cda27c8674654fca2834b9236a7.svg";
export { ForwardRef as ReactComponent };